const PORTAL_URL = import.meta.env.VITE_PORTAL_URL || 'https://app.zolym.com'

const mockApps = [
  { name: 'Asset Management', color: '#0E7C66' },
]

export default function Landing() {
  return (
    <div>

      {/* ── Hero ────────────────────────────────────────────────────────── */}
      <section className="hero-section">
        <div className="wrap hero-wrap">

          {/* Badge pill */}
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '6px 14px', borderRadius: 999,
            background: '#fff', border: '1px solid var(--border)',
            fontSize: 13, marginBottom: 28,
          }}>
            <span style={{
              background: 'var(--accent)', color: '#fff',
              fontSize: 10, fontWeight: 600, padding: '2px 6px', borderRadius: 4,
            }}>NEW</span>
            <span style={{ color: 'var(--body)' }}>IT Asset Management, built for modern teams</span>
          </div>

          {/* H1 */}
          <h1 className="hero-h1">
            Manage every asset from <span style={{ color: 'var(--accent)' }}>one</span> place.
          </h1>

          {/* Subcopy */}
          <p className="hero-sub">
            Hardware, software, licences, and procurement — tracked, assigned, and audited under a single admin layer.
          </p>

          {/* Actions */}
          <div className="hero-actions">
            <a href={PORTAL_URL} className="btn lg">
              Open the portal
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
            </a>
            <button className="btn lg ghost">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              Watch demo
            </button>
          </div>

          {/* Trust line */}
          <p className="zmono" style={{ fontSize: 12, color: 'var(--faint)', marginTop: 20, letterSpacing: '0.02em' }}>
            no credit card · 14-day trial · set up in minutes
          </p>
        </div>
      </section>

      {/* ── Product Mock ────────────────────────────────────────────────── */}
      <section style={{ padding: '0 0 80px' }}>
        <div className="wrap product-mock-wrap">
          <div style={{
            borderRadius: 'var(--radius-mock)', overflow: 'hidden',
            boxShadow: '0 30px 60px -30px rgba(10,10,11,.3)',
            border: '1px solid var(--border)',
          }}>
            {/* Browser chrome */}
            <div style={{
              height: 42, background: '#FAF9F6',
              display: 'flex', alignItems: 'center', padding: '0 16px', gap: 8,
              borderBottom: '1px solid var(--border)',
            }}>
              <div style={{ display: 'flex', gap: 6 }}>
                <i style={{ width: 10, height: 10, borderRadius: '50%', background: '#ddd', display: 'block' }} />
                <i style={{ width: 10, height: 10, borderRadius: '50%', background: '#ddd', display: 'block' }} />
                <i style={{ width: 10, height: 10, borderRadius: '50%', background: '#ddd', display: 'block' }} />
              </div>
              <span className="zmono" style={{ fontSize: 11, color: 'var(--faint)', marginLeft: 12 }}>portal.zolym.com</span>
            </div>

            {/* Portal top bar */}
            <div style={{
              height: 46, background: '#0A0A0B',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                <span style={{ color: '#fff', fontFamily: 'Jost', fontWeight: 300, fontSize: 14, letterSpacing: '0.28em' }}>
                  <span style={{ color: 'var(--accent)' }}>Z</span>OLYM
                </span>
                <span style={{ background: 'rgba(255,255,255,0.12)', color: '#fff', fontSize: 12, padding: '4px 10px', borderRadius: 6 }}>Apps</span>
                <span className="mock-admin-label" style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12 }}>Admin Center</span>
              </div>
              <span className="zmono mock-user-label" style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11 }}>tung.lt</span>
            </div>

            {/* Portal body */}
            <div style={{ background: 'var(--bg)', padding: '28px 28px 36px' }}>
              <span className="eyebrow" style={{ fontSize: 10 }}>apps · portal</span>
              <h3 style={{ fontWeight: 500, fontSize: 18, marginTop: 8, marginBottom: 20 }}>Your apps</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(1, 1fr)', gap: 14, maxWidth: 280 }}>
                {mockApps.map(app => (
                  <div key={app.name} style={{
                    background: '#fff', borderRadius: 12, border: '1px solid var(--border)',
                    padding: '18px 16px', display: 'flex', alignItems: 'center', gap: 12,
                  }}>
                    <div style={{
                      width: 40, height: 40, borderRadius: 10,
                      background: `${app.color}18`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      <div style={{ width: 20, height: 20, borderRadius: 5, background: app.color }} />
                    </div>
                    <span style={{ fontSize: 14, fontWeight: 500 }}>{app.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Logo Cloud ──────────────────────────────────────────────────── */}
      <section style={{ padding: '40px 0 60px' }}>
        <div className="wrap" style={{ textAlign: 'center' }}>
          <span className="eyebrow" style={{ color: 'var(--faint)' }}>trusted by modern teams</span>
          <div className="logo-cloud">
            {['Northwind', 'AXIOM', 'Polaris', 'Lumen', 'VERTEX'].map(name => (
              <span key={name} style={{ fontFamily: 'Jost', fontWeight: 500, fontSize: 16, letterSpacing: '0.05em', color: 'var(--muted)' }}>
                {name}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ── Apps Section ────────────────────────────────────────────────── */}
      <section>
        <div className="wrap" style={{ textAlign: 'center' }}>
          <span className="eyebrow">the platform</span>
          <h2 className="section-h2">
            Purpose-built apps. One source of truth.
          </h2>
          <p style={{ color: 'var(--body)', fontSize: 16, maxWidth: 560, margin: '14px auto 40px' }}>
            Start with Asset Management today. More apps are on the way — all sharing the same users, permissions, and data.
          </p>

          <div className="apps-grid">

            {/* Asset Management — LIVE */}
            <div style={{ background: '#fff', borderRadius: 16, border: '1px solid var(--border)', padding: 26 }}>
              <div style={{
                width: 48, height: 48, borderRadius: 12,
                background: 'var(--accent-tint)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16,
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="1.6">
                  <rect x="2" y="3" width="20" height="14" rx="2"/>
                  <path d="M8 21h8"/>
                  <path d="M12 17v4"/>
                </svg>
              </div>
              <h3 style={{ fontWeight: 500, fontSize: 19, marginBottom: 8 }}>Asset Management</h3>
              <p style={{ color: 'var(--body)', fontSize: 14.5, lineHeight: 1.55, textAlign: 'left' }}>
                IT & office assets, software licences, procurement, and spend tracking.
              </p>
              <a href={PORTAL_URL} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 14, fontSize: 13, fontWeight: 500, color: 'var(--accent)' }}>
                Open Asset Management →
              </a>
            </div>

            {/* Hiring Track */}
            <div style={{ background: '#fff', borderRadius: 16, border: '1px solid var(--border)', padding: 26, opacity: 0.72 }}>
              <div style={{
                width: 48, height: 48, borderRadius: 12,
                background: 'var(--accent-tint)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16,
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="1.6">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3 style={{ fontWeight: 500, fontSize: 19, marginBottom: 8 }}>Hiring Track</h3>
              <p style={{ color: 'var(--body)', fontSize: 14.5, lineHeight: 1.55, textAlign: 'left' }}>
                Hiring workflow: requests, approvals, job posting, pipeline, and interviews.
              </p>
              <span style={{ display: 'inline-flex', marginTop: 14, fontSize: 12, fontWeight: 500, color: 'var(--faint)', fontFamily: 'JetBrains Mono, monospace', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
                Coming soon
              </span>
            </div>

            {/* Dynamic Workflow Builder */}
            <div style={{ background: '#fff', borderRadius: 16, border: '1px solid var(--border)', padding: 26, opacity: 0.72 }}>
              <div style={{
                width: 48, height: 48, borderRadius: 12,
                background: 'var(--accent-tint)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16,
              }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="1.6">
                  <rect x="3" y="3" width="7" height="7" rx="1"/>
                  <rect x="14" y="3" width="7" height="7" rx="1"/>
                  <rect x="3" y="14" width="7" height="7" rx="1"/>
                  <path d="M17.5 17.5h.01"/>
                  <path d="M14 17.5h3.5v-3.5"/>
                </svg>
              </div>
              <h3 style={{ fontWeight: 500, fontSize: 19, marginBottom: 8 }}>Dynamic Workflow Builder</h3>
              <p style={{ color: 'var(--body)', fontSize: 14.5, lineHeight: 1.55, textAlign: 'left' }}>
                Build custom approval flows and automation rules — no code required.
              </p>
              <span style={{ display: 'inline-flex', marginTop: 14, fontSize: 12, fontWeight: 500, color: 'var(--faint)', fontFamily: 'JetBrains Mono, monospace', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
                Coming soon
              </span>
            </div>

          </div>
        </div>
      </section>

      {/* ── Stats Band ──────────────────────────────────────────────────── */}
      <section className="stats-section">
        <div className="wrap">
          <div className="stats-grid">
            {[
              { num: '1',     label: 'focused app, zero bloat', accent: true },
              { num: '$1.2M', label: 'assets tracked daily' },
              { num: '100%',  label: 'audit coverage' },
              { num: '99.9%', label: 'uptime' },
            ].map(s => (
              <div key={s.label} style={{ textAlign: 'center' }}>
                <div className="zmono" style={{
                  fontSize: 40, fontWeight: 500, letterSpacing: '-0.02em',
                  color: s.accent ? 'var(--accent)' : '#fff',
                }}>{s.num}</div>
                <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', marginTop: 6 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ─────────────────────────────────────────────────────────── */}
      <section style={{ textAlign: 'center' }}>
        <div className="wrap">
          <h2 className="section-h2">Take control of your assets.</h2>
          <p style={{ color: 'var(--body)', fontSize: 16, maxWidth: 480, margin: '14px auto 28px' }}>
            One login, one admin panel, full visibility. Stop managing assets in spreadsheets.
          </p>
          <a href={PORTAL_URL} className="btn lg">
            Open the portal
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
          </a>
        </div>
      </section>

    </div>
  )
}
